import styled, { css } from 'styled-components';
import { color } from 'styled-system';
import { shouldForwardProp } from '../../utils';
import { strictSpace } from '../../utils';
export var ButtonSize;

(function (ButtonSize) {
  ButtonSize["Small"] = "small";
  ButtonSize["Medium"] = "medium";
  ButtonSize["Large"] = "large";
})(ButtonSize || (ButtonSize = {}));

export var ButtonState;

(function (ButtonState) {
  ButtonState["Success"] = "success";
  ButtonState["Error"] = "error";
  ButtonState["Loading"] = "loading";
  ButtonState["Disabled"] = "disabled";
})(ButtonState || (ButtonState = {}));

export var buttonResetMixin = css(["position:relative;box-sizing:border-box;appearance:none;border:none;user-select:none;background-color:transparent;text-decoration:none;text-transform:none;cursor:pointer;outline:none;overflow:hidden;&:focus{outline:0;}"]);
export var enabledBtnStyles = css(["&::after{background-color:", ";background-color:", ";}&:focus{box-shadow:", ";}&:hover{&::after{opacity:1;}&::before{opacity:0;}}"], function (_ref) {
  var hoverBgColor = _ref.hoverBgColor;
  return hoverBgColor;
}, function (_ref2) {
  var state = _ref2.state,
      errorHoverBgColor = _ref2.errorHoverBgColor,
      successHoverBgColor = _ref2.successHoverBgColor,
      hoverBgColor = _ref2.hoverBgColor;
  return state === ButtonState.Error ? errorHoverBgColor : state === ButtonState.Success ? successHoverBgColor : hoverBgColor;
}, function (_ref3) {
  var theme = _ref3.theme,
      focusColor = _ref3.focusColor;
  return [theme.bordersAsShadows.border4, focusColor || theme.colors.borderFocused].join(' ');
});
var StyledButton = styled.button.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Buttons__StyledButton",
  componentId: "sc-xht9q4-0"
})(["", " ", ";", ";", ";padding-left:", ";padding-right:", ";background-color:", ";border-radius:", ";display:", ";justify-content:center;align-items:center;height:", ";width:", ";transition:transform ", ";&::after,&::before{content:'';position:absolute;border-radius:", ";background-color:", ";width:100%;height:100%;opacity:0;left:0;top:0;transition:opacity ", ";}", " ", " ", ""], buttonResetMixin, strictSpace, color, function (props) {
  return props.isIconButton && css(["> div,svg{width:", ";height:", ";}> div{z-index:1;position:relative;}"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.space.s24;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.space.s24;
  });
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.space.s16;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.s16;
}, function (_ref8) {
  var state = _ref8.state,
      mainBgColor = _ref8.mainBgColor,
      errorBgColor = _ref8.errorBgColor,
      successBgColor = _ref8.successBgColor;
  return state === ButtonState.Error ? errorBgColor : state === ButtonState.Success ? successBgColor : mainBgColor;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.borderRadius.radiusRound;
}, function (_ref10) {
  var size = _ref10.size;
  return size === ButtonSize.Large ? 'flex' : 'inline-flex';
}, function (_ref11) {
  var theme = _ref11.theme,
      size = _ref11.size;
  return size === ButtonSize.Small ? theme.space.s36 : size === ButtonSize.Medium ? theme.space.s48 : theme.space.s56;
}, function (_ref12) {
  var theme = _ref12.theme,
      size = _ref12.size,
      isIconButton = _ref12.isIconButton;
  return isIconButton ? theme.space.s56 : size === ButtonSize.Large ? '100%' : 'auto';
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.duration.duration150;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.borderRadius.radiusRound;
}, function (_ref15) {
  var mainBgColor = _ref15.mainBgColor;
  return mainBgColor;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.duration.duration150;
}, function (_ref17) {
  var disabled = _ref17.disabled,
      state = _ref17.state;
  return !disabled && state !== ButtonState.Disabled && enabledBtnStyles;
}, function (_ref18) {
  var disabled = _ref18.disabled,
      loading = _ref18.loading,
      state = _ref18.state,
      disabledBgColor = _ref18.disabledBgColor;
  return (disabled || state === ButtonState.Disabled) && !loading && state !== ButtonState.Loading && css(["cursor:not-allowed;background-color:", ";"], disabledBgColor);
}, function (_ref19) {
  var loading = _ref19.loading,
      state = _ref19.state;
  return loading || state === ButtonState.Loading && css(["cursor:progress;"]);
});
export default StyledButton;